export class EditTitleComponent implements ng.IComponentOptions {
    public controller = function () {
        const $ctrl = this;

        let _title = undefined;
        $ctrl.title = function(title) {
            if (arguments.length) {
                _title = title;
            }

            return _title !== undefined ? _title : this.resolve.title;
        };

        $ctrl.confirm = function () {
            $ctrl.close({$value: $ctrl.title()});
        };
    };

    public bindings = {
        resolve: '<',
        close: '&',
        dismiss: '&',
    };

    public template = `<div class="modal-header">
        <h3 class="modal-title">Edit soil summary title</h3>
    </div>
    <div class="modal-body settings-modal">
        <input type="text" class="w-100"
               name="pinTitle"
               ng-model-options="{ getterSetter: true }"
               ng-model="$ctrl.title"/>
    </div>
    <div class="modal-footer">
        <button class="btn-rounded btn-cancel" type="button" ng-click="$ctrl.dismiss()" data-action="dismissPinTitle">Cancel</button>
        <button class="btn-rounded btn-primary" type="button" ng-click="$ctrl.confirm()" data-action="confirmPinTitle">Done</button>
    </div>`;
}